export default {
  name: 'Name',
  address: 'Address',
  phoneNumber: 'Phone Number',
  register: 'Create Clinic',
  clinicName: 'Clinic Name',
  list: 'Clinics List',
};
